import { makeStyles } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import MailOutline from "@material-ui/icons/MailOutline";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import PropTypes from "prop-types";
import CustomInput from "components/CustomInput/CustomInput";
import { useParams, Redirect } from "react-router-dom";
import { travelApi } from "functions/apis";

const useStyles = makeStyles(styles);

const DeleteMerchantInventoryControlGroup = props => {
  const classes = useStyles();

  const [input, setInput] = useState({
    code: "",
    name: ""
  });
  const [redirect, setRedirect] = useState(false);

  const { id } = useParams();

  const deleteMerchantInventoryControlGroupSignal = useRef(
    new AbortController()
  );

  useEffect(() => {
    return () => deleteMerchantInventoryControlGroupSignal.current.abort();
  }, []);

  useEffect(() => {
    if (id) {
      travelApi
        .get("inventoryControlGroups/" + id, {
          signal: deleteMerchantInventoryControlGroupSignal.current.signal
        })
        .then(resp => {
          setInput(resp);
        });
    }
  }, [id]);

  const handleDelete = e => {
    e.preventDefault();
    travelApi
      .delete("inventoryControlGroups/" + id, {
        signal: deleteMerchantInventoryControlGroupSignal.current.signal
      })
      .then(() => {
        setRedirect(true);
      });
  };

  return redirect ? (
    <Redirect to={"/admin/MerchantInventoryControlGroupList"} />
  ) : (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              DELETE MERCHANT INVENTORY CONTROL GROUP
            </h4>
          </CardHeader>
          <CardBody>
            <i>
              *Are you sure to delete this merchant inventory control group?
            </i>
            <form onSubmit={handleDelete}>
              <Button onClick={() => props.history.goBack()} value="Cancel">
                CANCEL
              </Button>
              <Button color="rose" type="submit" value="Submit">
                DELETE
              </Button>
            </form>
            <form>
              <CustomInput
                labelText="Code"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: input.code,
                  disabled: true
                }}
              />
              <CustomInput
                labelText="Name"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: input.name,
                  disabled: true
                }}
              />
            </form>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default DeleteMerchantInventoryControlGroup;

DeleteMerchantInventoryControlGroup.propTypes = {
  history: PropTypes.object
};
